import { GenIcon } from '../helpers/IconBase.es.js';

const FlashOnFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M8 2C7.44772 2 7 2.44772 7 3V12C7 12.5523 7.44772 13 8 13H9C9.55228 13 10 13.4477 10 14V20.1505C10 20.6609 10.6747 20.8433 10.9319 20.4025L16.1227 11.5039C16.5116 10.8372 16.0308 10 15.259 10H13.809C13.4373 10 13.1956 9.60884 13.3618 9.27639L16.2764 3.44721C16.6088 2.78231 16.1253 2 15.382 2H8Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { FlashOnFilled };
